
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoTypeGrid extends Serenity.EntityGrid<PsAdvPromoTypeRow, any> {
        protected getColumnsKey() { return PsAdvPromoTypeColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoTypeDialog; }
        protected getIdProperty() { return PsAdvPromoTypeRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoTypeRow.localTextPrefix; }
        protected getService() { return PsAdvPromoTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
			var button = super.getButtons();
            
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}